import React, { useState, useEffect } from 'react';
import { usersRef, getUserRef, serverTimestamp } from '../../firebase/collections';
import AdminLayout from '../../Components/Admin/AdminLayout';

function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    let q = usersRef().limit(100);
    if (statusFilter) {
      q = usersRef().where('accountStatus', '==', statusFilter).limit(100);
    }
    q.get()
      .then((snap) => {
        setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .finally(() => setLoading(false));
  }, [statusFilter]);

  const setAccountStatus = (userId, accountStatus) => {
    getUserRef(userId).update({ accountStatus, updatedAt: serverTimestamp() }).then(() => {
      setUsers((prev) => prev.map((u) => (u.id === userId ? { ...u, accountStatus } : u)));
    });
  };

  return (
    <AdminLayout>
      {/* SECTION HEADER — From Mockup */}
      <div className="sec-hdr">
        <div className="sec-label green">Management</div>
        <h1 className="sec-title">User Database</h1>
        <p className="sec-sub">Manage roles, status, and trust scores for all golfers.</p>
      </div>

      {/* SEARCH/FILTER STRIP — From Mockup */}
      <div className="search-strip" style={{ position: 'static', margin: '24px 0', padding: '15px' }}>
        <span style={{ fontSize: '14px', fontWeight: '700', color: 'var(--cl-grey)' }}>Filter Accounts: </span>
        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{ width: '200px' }}
        >
          <option value="">All Statuses</option>
          <option value="active">Active</option>
          <option value="suspended">Suspended</option>
          <option value="banned">Banned</option>
          <option value="deactivated">Deactivated</option>
        </select>
        <div style={{ marginLeft: 'auto', fontSize: '12px', color: 'var(--cl-mid)' }}>
          Showing {users.length} results
        </div>
      </div>

      {loading ? (
        <div className="sec-sub">Loading golfers...</div>
      ) : (
        <div className="adminTableWrap" style={{ boxShadow: 'var(--cl-shadow)', border: '1px solid #eee' }}>
          <table className="adminTable">
            <thead>
              <tr>
                <th>GOLFER DETAILS</th>
                <th>ROLE</th>
                <th>ACCOUNT STATUS</th>
                <th>TRUST SCORE</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="olxFadeIn">
                  <td>
                    <div className="mini-info">
                      <div className="mini-name">{u.name || 'Unknown Golfer'}</div>
                      <div className="mini-sub">{u.email}</div>
                      <div className="mini-sub" style={{ fontSize: '9px' }}>ID: {u.id}</div>
                    </div>
                  </td>
                  <td>
                    {/* Using Grade Tag style for Roles */}
                    <span className={`mini-grade ${u.role === 'admin' ? 'g-aplus' : 'g-c'}`}>
                      {u.role || 'user'}
                    </span>
                  </td>
                  <td>
                    {/* Using Category Card style for Status */}
                    <span className={`cat-card-count ${u.accountStatus === 'banned' ? 'women' : 'boys'}`} style={{ fontSize: '11px' }}>
                      {u.accountStatus || 'active'}
                    </span>
                  </td>
                  <td>
                    <div className="mini-price" style={{ color: 'var(--green)' }}>
                      {u.trustScore ?? '—'}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      {(u.accountStatus === 'active' || !u.accountStatus) && (
                        <>
                          <button
                            className="btn btn-outline"
                            style={{ padding: '6px 12px', fontSize: '11px' }}
                            onClick={() => setAccountStatus(u.id, 'suspended')}
                          >
                            Suspend
                          </button>
                          <button
                            className="btn btn-green"
                            style={{ padding: '6px 12px', fontSize: '11px', background: '#e53935' }}
                            onClick={() => setAccountStatus(u.id, 'banned')}
                          >
                            Ban
                          </button>
                        </>
                      )}
                      {u.accountStatus === 'suspended' && (
                        <button
                          className="btn btn-gold"
                          style={{ padding: '6px 12px', fontSize: '11px' }}
                          onClick={() => setAccountStatus(u.id, 'active')}
                        >
                          Reactivate
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminUsers;
